__turbopack_context__.v({
  "desktopPanelContent": "panelLayout-module-scss-module__Xd28Za__desktopPanelContent",
  "leftRow": "panelLayout-module-scss-module__Xd28Za__leftRow",
  "rightRow": "panelLayout-module-scss-module__Xd28Za__rightRow",
  "rowsContainer": "panelLayout-module-scss-module__Xd28Za__rowsContainer",
  "subHeaderRow": "panelLayout-module-scss-module__Xd28Za__subHeaderRow",
});
